//react imports
import React from 'react';
//css imports

//components imports

import { Aux } from '../../../hoc/Aux';

//external libraries import



 const InputElement = (props) => {
   const valueIdentifier = (inputIdentifier)=>{

   }


  const pickDetails = (event,inputIdentifier)=>{
    
    // let value=document.getElementById(props.inputName).value;
    // console.log(value);
    // this.props.collectValue(value);
    const  value = event.target.value;
    if(validation(value)){
      console.log("[InputElement.js] ValidInput");
      props.pickValues(value,inputIdentifier)

    }

    // let inputValue = [
    //   ...props.inputValues
    // ]

    // inputValue.push(value);
    // props.pickValues(inputValue);
 }

  const validation=(value)=>{
    console.log("[InputElement.js] validating input for empty tesing for",value,value.trim().length);
    if(value.trim().length)
      return true;
    
    else
      return false;
    
  }
 
  return (

    <Aux>
        {/* Label For Focus On Click */}
        <label htmlFor={props.inputName}>{props.inputName}</label>
        {/* Input Nox here applying all passed props */}
        <input type={props.type}  className='form-control'
         onBlur={(event)=>{pickDetails(event,props.queryID)}} id={props.queryID} value={props.value} />
    </Aux>

  );
 }



export default InputElement;



// WEBPACK FOOTER //
// ./src/Components/UI/InputElement/InputElement.js